/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/PaymentCompletedDialog/theme';

export const PaymentCompletedDialogTheme = theme;
